import * as React from 'react';
import { GenericErrorScreen } from 'mini-error-handler/lib/components/GenericErrorScreen';
import { getEmptyStateDisplayProperties } from '../utils/mailList/getEmptyStateDisplayProperties';
import { getPackageBaseUrl } from 'owa-config';
import { MailListEmptyScreenProps } from '../schema/MailListEmptyScreen.types';
import { urlResolve } from 'mini-common-utils/lib/utils/urlResolve';
import { useTheme } from 'mini-theme/lib/contexts/ThemeContext';

const styles = require('./MailListEmptyState.scss');
const classNames = require('classnames/bind').bind(styles);

export const MailListEmptyScreen = (props: MailListEmptyScreenProps): JSX.Element => {
    const { folderName, viewFilter, className, focusedViewFilter } = props;

    const { isDarkTheme } = useTheme();

    const { title, subtitle, imageSrc } = getEmptyStateDisplayProperties(
        folderName,
        viewFilter,
        focusedViewFilter,
        isDarkTheme
    );

    const EmptyStateImage = (
        <img
            src={urlResolve(getPackageBaseUrl(), imageSrc)}
            aria-hidden
            alt=""
            role="presentation"
        />
    );

    return (
        <GenericErrorScreen
            image={EmptyStateImage}
            isFullScreen={true}
            title={title}
            subtitle={subtitle}
            containerClassName={classNames('emptyListElementContainer', className)}
            showDefaultActionButton={false}
        />
    );
};
